import {initElements} from "../define/shared"

export default function initFaqBlock() {
    initElements(".faq.wa-block", block => {
        const questions = block.querySelectorAll(".question")

        questions.forEach(question => {
            question.querySelector(".question-title").addEventListener("click", () => {
                question.classList.toggle("is--open")
            })
        })
    })
}
